module.exports = __webpack_public_path__ + "static/media/Screenshot_5-thumb.11881ee8.png";